import React, { useEffect, useState } from 'react';
// import { S3 } from 'aws-sdk';
import { decode } from 'base-64';
import {
    getOfferDetails,
    getProfile,
    getCandidateJobDetails,
    updateFresherStatus,
    updateExpStatus,
    getPreliminaryDetails,
    getSummaryDetails,
    sendFeedback,
    getInterviewRound,
    sendMail,
    postFresherFeedback,
    postExpFeedback,
    postFresherInterchange,
    postExpInterchange,
    getPrelimFeedback,
    postTimeline,
    getReportingDetails,
    getRejectedReason,
    getJob,
    getFresherEvaluation,
    updatePrelimAns,
} from '../service/RecruiterApi';
import CandidateBasicDetails from './candidateBasicDetails';
import CandidateInterview from './candidateInterview';
import CandidateOffer from './candidateOffer';
import CandidateProfile from './candidateProfile';
import CandidateTask from './candidateTask';
import CandidateTimeline from './candidateTimeline';
import moment from 'moment';
import CandidateDocumentDetails from './candidateDocumentDetails';
// import Loader from '../../StaticComponent/Loader';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import { candidateclient } from '../service/RecruiterClient';
import { Feedback } from 'precise-ui/dist/es6/components/Icon/icons';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';
import RecruitmentPopup from './RecruitmentPopup/RecruitmentPopup';
import BlockPopup from './RecruitmentPopup/BlockPopup';
import EvaluationPopUp from '../components/EvaluationPopUp';
import { getUserServiceLevelDetails } from '../service/adminApi';
import { RecruitmentComponent } from './recruitment';
import { getS3 } from '../utils/Download.js';
import parse from 'html-react-parser';
//import "../RecruitmentCss/css/candidate-overview.css";

export function CandidateOverview() {
    const search = window.location.search;
    const navigate = useNavigate();
    const candidate_id = new URLSearchParams(search).get('id');
    const experience = new URLSearchParams(search).get('exp');
    const JobID = new URLSearchParams(search).get('jId');
    let role = '';
    const recruitRole = encryptStorage.getItem('recruitRole');
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [jobTitle, setJobTitle] = useState();
    const [editData, setEditData] = useState([])
    let object = {
        first_name: '',
        last_name: '',
        email_id: '',
        mobile_number: '',
    };

    let offerObject = {
        offerletter_status: '',
        on_boarding_date: '',
        annual_ctc: '',
        currency_type: '',
        modified_at: '',
        url: '',
    };

    let jobsObj = {
        department: '',
        employment_type: '',
        job_id: '',
        job_title: '',
        location: '',
        stage: '',
        status: '',
    };

    let defaultReportDetails = {
        offerValid: '',
        HRPartner: '',
        reportingManager: '',
        reporting_id: '',
    };

    const [offerData, setOfferData] = useState(offerObject);
    const [rejectdata, setRejectData] = useState([]);
    const [overviewData, setOverviewData] = useState(object);
    const [candidateJobsData, setCandidateJobsData] = useState(jobsObj);
    const [reportingDetails, setReportingDetails] = useState(defaultReportDetails);
    const [isLoading, setIsLoading] = React.useState(true);

    const [preliminaryData, setpreliminaryData] = useState([]);
    //state variable for edit icon
    const [editPrelims, setEditPrelims] = useState('');
    //state variable to store the preliminary data response
    const [prevPrelim, setPrevPrelim] = useState([]);

    let job_id = new URLSearchParams(search).get('jId');
    let onboard_id = new URLSearchParams(search).get('val');
    //PS_SB_02
    const [summaryData, setSummaryData] = useState([]);
    const [fresherData, setfresherData] = useState([]);
    const [roundId, setroundId] = useState('');
    const [hideDecisionButton, sethideDecisionButton] = useState('');
    const [renderFlag, setRenderFlag] = useState(true);
    const [InterviewRoundDD, setInterviewRoundDD] = useState([]);
    let [jobsDD, setJobsDD] = useState([]);

    let [interchangeData, setInterchangeData] = useState({
        job_id: '',
        job_title: '',
    });
    let [hideInterchange, setHideInterchange] = useState(true);
    let [hideGenerateOffer, sethideGenerateOffer] = useState(true);

    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('recruitRole') == 'Panel Member') {
            loadSummaryData();
            loadData();
            InterviewRound();
            getDropdowns();
            getJobName();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, [renderFlag]);

    useEffect(() => { }, []);
    let getJobName = async () => {
        try {
            if (job_id !== null || job_id !== undefined) {
                let response = await getJob({ job_id: job_id });

                setJobTitle(response?.data?.data[0]?.job_title);
            }
        } catch (e) {
            throw e;
        }
    };

    let InterviewRound = async () => {
        try {
            let resp = await getInterviewRound({ job_id });
            setInterviewRoundDD(resp.data.data[0]);
        } catch (e) {
            throw e;
        }
    };
    let cancelClick = (value) => {
        if (value == 'Move') {
            setInterchangeData({ job_id: '', job_title: '' });
        }
    };
    // Insert the submitHold data
    let submitHold = async (value) => {
        if (value == 'InterChange') {
            if (experience == 'Fresher') {
                let resp = await postFresherInterchange({
                    job_id: interchangeData.job_id,
                    id: [candidate_id],
                });
                let content = {
                    Subject: `Job Matching your skillset`,
                    body: `<html lang="en">
    
                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>
                    
                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                        </div>
                       </div>
                    
                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${overviewData.first_name},
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        Hope your day is going great! <br/><br/>

              As you might be aware that we have openings for ${interchangeData.job_title} , we would like to move your profile to ${interchangeData.job_title} position as it matches the required skillset. <br/> <br/>
              
              Please find this as an official notification for proceeding with the same! <br/><br/>
              
              We wish you the very best!  <br/><br/>
              Please click in the following link:   <a href="https://hivecandidate.avasoft.com?id=${interchangeData.job_id}">https://hivecandidate.avasoft.com?id=${interchangeData.job_id}</a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>
                      
                    </div>
                    </body>
                    </html>`,
                    to: [overviewData?.email_id],
                };
                sendMail(content);
            } else {
                let resp1 = await postExpInterchange({
                    job_id: interchangeData.job_id,
                    id: [candidate_id],
                });
                let content = {
                    Subject: `Job Matching your skillset`,
                    body: `<html lang="en">
    
                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>
                    
                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                        </div>
                       </div>
                    
                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${overviewData.first_name},
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        Hope your day is going great! <br/>

              As you might be aware that we have openings for ${interchangeData.job_title} , we would like to move your profile to ${interchangeData.job_title} position as it matches the required skillset.  <br/><br/>
              
              Please find this as an official notification for proceeding with the same! <br/><br/>
              
              We wish you the very best!  <br/><br/>
              Please click in the following link: <a href="https://hivecandidate.avasoft.com?id=${interchangeData.job_id}"></a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>
                      
                    </div>
                    </body>
                    </html>`,
                    to: [overviewData?.email_id],
                };
                sendMail(content);
            }
            setHideInterchange(true);
            navigate('/Recruitment');
        }
    };
    let getDropdowns = async () => {
        let job_id = new URLSearchParams(search).get('jId');
        let data = {
            job_id: job_id,
        };
        let ddResp = await getInterviewRound(data);

        setJobsDD(ddResp?.data?.data[2]);
    };

    let bindJobsTitle = () => {
        try {
            return jobsDD?.map((obj, index) => {
                return (
                    <option hidden={obj.experience != experience} key={index} value={obj.id + '@' + obj.job_title}>
                        {obj.job_title}
                    </option>
                );
            });
        } catch (e) { }
    };
    let feedbackClick = async (e) => {
        try {
            let data = {
                round_id: e.target.id,
                candidate_id: candidate_id,
                overall_recommendation_id: '1',
                overall_comments: '',
            };
            if (experience == 'Fresher') {
                let response = await postFresherFeedback(data);
                setinsertToast(true);
                setToastColor('green');

                setToastPara(`Successfully Selected in ` + e.target.name);
                setToastValue('Successfully Selected');
            } else {
                let response = await postExpFeedback(data);
                setinsertToast(true);
                setToastColor('green');

                setToastPara(`Successfully Selected in ` + e.target.name);
                setToastValue('Successfully Selected');
            }
        } catch (e) {
            throw e;
        }
    };

    let loadSummaryData = async () => {
        try {
            //
            let response = await getPreliminaryDetails({
                id: candidate_id,
                experience: experience,
            });

            setpreliminaryData(response.data.data);
            //setstate the PrevPrelim with the response
            setPrevPrelim(response.data.data);

            //setroundId(response.data.data[0].roundid);
            let prelim = await getPrelimFeedback({ candidate_id: candidate_id, experience: experience });

            sethideDecisionButton(prelim?.data?.data[0]?.overall_recommendation_id);

            //
            //PS_SB_04-05
            let response2 = await getSummaryDetails({
                id: candidate_id,
                experience: experience,
            });
            let val = response2.data.data;

            for (let i = 0; i < val.length; i++) {
                if (val[i].interview_round_name == 'Final Round') {
                    // if (val[i].overall_recommendation_id == 1) {
                    sethideGenerateOffer(false);
                    //}
                }
            }

            setSummaryData(response2.data.data);
            let fresherRoundDatas = await getFresherEvaluation({ candidate_id: candidate_id });
            setfresherData(fresherRoundDatas.data.data);
        } catch (e) { }
    };

    /**
     * PS_PR_04 - PS_PR_09 - Get the Family and location details with the help of getProfile()
     * PS_PR_10 - Store the Family and location details in resoObj
     */
    let loadData = async () => {
        
        try {
            setIsLoading(false);

            let resp1 = await getProfile({
                id: candidate_id,
                experience: experience,
            });
            setIsLoading(true);

            var value = resp1.data.data[0];


            let respObj = {
                first_name: value?.first_name,
                middle_name: value?.middle_name,
                last_name: value?.last_name,
                email_id: value?.email_id,
                mobile_number: value?.mobile_number,
                alternate_mobile_number: value?.alternate_mobile_number,
                gender: value?.gender,
                date_of_birth: value?.date_of_birth,
                email_id: value?.email_id,
                house: value?.house,
                street: value?.street,
                city: value?.city,
                area: value?.area,
                country: value?.country,
                state: value?.state,
                pincode: value?.pincode,
                portfolio_link: value?.portfolio_link,
                interview_source: value?.interview_source,
                resume_url: value?.resume_url,
                candidate_photo_url: value?.candidate_photo_url,
                job_source_name: value?.job_source_name,
                father_salary: value?.father_salary,
                father_occupation: value?.father_occupation,
                mother_occupation: value?.mother_occupation,
                mother_salary: value?.mother_salary,
                native_location: value?.native_location,
                current_location: value?.current_location,
                siblings: Array.isArray(value?.siblings) ? value?.siblings.map(sibling => ({
                    sibling_occupation: sibling.sibling_occupation,
                    sibling_salary: sibling.sibling_salary
                })) : [],
            };
            setOverviewData(respObj);
           
            getCandidateJobDetails({
                candidate_id: candidate_id,
                experience: experience,
            })
                .then((resp2) => {
                    
                    var object = {
                        department: resp2.data.data[0].department,
                        employment_type: resp2.data.data[0].employment_type,
                        job_id: resp2.data.data[0].job_id,
                        job_title: resp2.data.data[0].job_title,
                        location: resp2.data.data[0].location,
                        stage: resp2.data.data[0].stage,
                        status: resp2.data.data[0].status,
                        posted_by: resp2.data.data[0].emp_name,
                    };
                    setCandidateJobsData(object);
                })
                .catch((e) => { });
            setIsLoading(false);

            let resp = await getOfferDetails({
                id: candidate_id,
                experience: experience,
            });
            setIsLoading(true);
            var offerValue = resp.data.data[0];

            var offerObject = {
                offerletter_status: offerValue.offerletter_status,
                on_boarding_date: offerValue.on_boarding_date,
                annual_ctc: offerValue.annual_ctc,
                currency_type: offerValue.currency_type,
                modified_at: offerValue.modified_at,
                url: offerValue.offerletter_url,
            };
            setOfferData(offerObject);
            const reason = await getRejectedReason({
                candidate_id: candidate_id,
                exp: experience,
            });
            setRejectData(reason.data.data[0]);

            const response = await getReportingDetails({ candidate_id, exp: experience });
            let data = {
                offerValid: moment(response.data.data[0].offer_valid_till).format('MMM DD, YYYY'),
                HRPartner: response.data.data[0].hr_manager,
                reportingManager: response.data.data[0].reporting_manager,
            };
            setReportingDetails(data);
            // ;
            // let response = await getPreliminaryDetails({ id: candidate_id, experience: experience });

            // setpreliminaryData(response.data.data)

            //

            // ;

            // let response2 = await getSummaryDetails({ id: candidate_id, experience: experience });

            // setSummaryData(response2.data)

            //
        } catch (e) { }
    };

    const statusUpdate = async (result) => {
        let res = {
            candidate_id: candidate_id,
            experience: experience,
            recommendation_id: result,
            overAllComments: result == 1 ? 'selected' : 'rejected',
            interview_id: 0,
        };
        sethideDecisionButton(result);

        let resp = await sendFeedback(res);

        if (resp.data.statusCode == 200) {
            setRenderFlag(!renderFlag);
        }
    };

    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'Jobs', path: '/Recruitment', isActive: true },
        {
            title: candidateJobsData.job_title,
            path: `/Recruitment/Jobs?id=${job_id}`,
            isActive: true,
        },
        { title: overviewData.first_name, path: `/Recruitment/Jobs?id=${job_id}`, isActive: false },
    ];

    let rejectOrBlockClick = async (value) => {
        let emp = [];

        emp.push(candidate_id);

        if (value == 'Rejected') {
            // const repsonse = await sendMail({
            //     data: 'Sorry you are rejected! Please try again',
            // });
        }
        if (experience == 'Fresher') {
            let resp = await updateFresherStatus({ status: value, id: emp });
            navigate(`/Recruitment/Jobs?id=${job_id}`);
        }
        if (experience == 'Experienced') {
            let resp1 = await updateExpStatus({ status: value, id: emp });
            navigate(`/Recruitment/Jobs?id=${job_id}`);
        }
    };

    var highLightColor1 = '',
        highLightColor2 = '',
        highLightColor3 = '',
        highLightColor4 = '',
        highLightColor5 = '';

    if (candidateJobsData.stage == 'Sourcing') {
        highLightColor1 = 'recruit-stage-complete regular-text active';
        highLightColor2 = '';
        highLightColor3 = '';
        highLightColor4 = '';
        highLightColor5 = '';
    } else if (candidateJobsData.stage == 'Offer') {
        highLightColor1 = 'recruit-stage-complete regular-text';
        highLightColor2 = 'recruit-stage-complete regular-text';
        highLightColor3 = 'recruit-stage-complete regular-text';
        highLightColor4 = 'recruit-stage-complete regular-text active';
        highLightColor5 = '';
    } else if (candidateJobsData.stage == 'Screening') {
        highLightColor1 = 'recruit-stage-complete regular-text';
        highLightColor2 = 'recruit-stage-complete regular-text active';
        highLightColor3 = '';
        highLightColor4 = '';
        highLightColor5 = '';
    } else if (candidateJobsData.stage == 'Hire') {
        highLightColor1 = 'recruit-stage-complete regular-text';
        highLightColor2 = 'recruit-stage-complete regular-text';
        highLightColor3 = 'recruit-stage-complete regular-text';
        highLightColor4 = 'recruit-stage-complete regular-text';
        highLightColor5 = 'recruit-stage-complete regular-text active';
    } else if (candidateJobsData.stage == 'Interview') {
        highLightColor1 = 'recruit-stage-complete regular-text';
        highLightColor2 = 'recruit-stage-complete regular-text';
        highLightColor3 = 'recruit-stage-complete regular-text active';
        highLightColor4 = '';
        highLightColor5 = '';
    }

    const premilaryBind = () => {
        const AccordHeading = () => {
            try {
                return (
                    <>
                        <h2 className="accordion-header recruit-timeline-spacing" id="headingOne">
                            <div className="row align-items-center">
                                <div className="col-md-5">
                                    <button
                                        className="recruit-accordion-button w-auto px-0 regular-text"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="false"
                                        aria-controls="collapseOne"
                                    >
                                        Preliminary Evaluation
                                    </button>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="d-flex align-items-center recruit-border-right pe-4">
                                            {/* <span className="recruit-summary-initial bold-text"></span> */}
                                            {/* <span className="recruit-summary-username regular-text"></span> */}
                                        </div>
                                        <div className="font-14 d-flex align-items-center ps-4 regular-text">
                                            {moment(preliminaryData[0].created_at).format('MMM DD, YYYY')}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="font-14 d-flex justify-content-end">
                                        {/* <button
                                            className="custom-task-red-btn font-14 regular-text me-2"
                                            hidden={hideDecisionButton ? true : false}
                                            onClick={() => statusUpdate('2')}
                                        >
                                            <span>
                                                <img src="/Images/Cross-task.svg" className="btn-size" />
                                            </span>
                                            Reject
                                        </button>
                                        <button
                                            className="custom-task-green-btn font-14 regular-text"
                                            hidden={hideDecisionButton ? true : false}
                                            onClick={() => statusUpdate('1')}
                                        >
                                            <span>
                                                <img src="/Images/tick-task.svg" className="btn-size" />
                                            </span>
                                            Select
                                        </button> */}
                                        {/* {hideDecisionButton == 1 ? ( */}
                                        <>
                                            <img src="/Images/tick-task.svg" className="me-2" alt="Tick Icon" />
                                            <span> Selected</span>{' '}
                                        </>

                                        {/* {hideDecisionButton == 2 ? (
                                            <>
                                                <img src={'/Images/Cross-task.svg'} className="me-2" />
                                                <span> Rejected</span>{' '}
                                            </>
                                        ) : null} */}
                                    </div>
                                </div>
                            </div>
                        </h2>
                    </>
                );
            } catch (e) { }
        };

        try {
            return (
                <>
                    <div className="accordion-item border-0">
                        {AccordHeading()}

                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                        >
                            <div className="accordion-body recruit-bg">
                                {preliminaryData.map((prelim) => {

                                    return (
                                        <div className="mb-3">
                                            {/* on hovering the field, edit icon will be shown and on clicking edit icon, answer field will be enabled to input field to edit the answers */}
                                            <p className="recruit-summary-ques mb-1 regular-text">
                                                <span className="qus-content">{prelim.question}</span>
                                                <span
                                                    className="icon-edit"
                                                    onClick={() => {
                                                        setEditPrelims(prelim.id);
                                                    }}
                                                ></span>
                                            </p>
                                            {editPrelims != prelim.id ? (
                                                <p className="recruit-summary-ans regular-text">
                                                    {prelim.answer == '' ? '-' : prelim.answer}
                                                </p>
                                            ) : (
                                                <input
                                                    type="text"
                                                    class="form-control custom-textfield job-posting-form-control semi-bold-text job-posting-spacing job-posting-spacing"
                                                    maxlength="50"
                                                    onChange={(e) => handlePrelimChange(prelim.id, e.target.value)}
                                                ></input>
                                            )}
                                        </div>
                                    );
                                })}

                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                    <button
                                        className="btn hive-btn-secondary me-3"
                                        hidden={editPrelims == ''}
                                        onClick={() => {
                                            setpreliminaryData(prevPrelim);
                                            setEditPrelims('');
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn hive-btn-primary"
                                        hidden={editPrelims == ''}
                                        onClick={() => {
                                            setEditPrelims('');
                                            updatePrelim();
                                        }}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        } catch (e) { }
    };

    //onchange function for preliminary data

    const handlePrelimChange = (prelimID, e) => {


        const updatedPrelim = preliminaryData.map(value =>
            value.id === prelimID ? { ...value, answer: e } : value);
        preliminaryData.map((value) => {
            if (value.id === prelimID) {
                let arr = editData
                let obj = {
                    answer: e,
                    question_id: prelimID
                }

                arr.push(obj)
                setEditData(arr)
            }
        })
        // setPrelimUpdated(...prilimUpdated,updatedPrelim)
        setpreliminaryData(updatedPrelim)
    };
  

    //preliminary data update function
    const updatePrelim = async () => {
        
        let resp = await updatePrelimAns({
            //PC_PA_3 call the update function by sending the values as parameters
            preliminaryData: editData,
            id: candidate_id,
            exp: experience,
        });
    };

    // function signedURL(urls, expired_in = "") {
        
    //     try {
    //         // Extract the path portion from the URL
    //         const path = new URL(urls).pathname;

    //         // Remove leading slash if present
    //         const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

    //         // Decode URI components to handle special characters
    //         const decodedPath = decodeURIComponent(cleanedPath);

    //         const modifiedString = removeFirstAndLastThree('');

    //         // Decoding the encoded string
    //         const decodedStringaccessKey = decode(modifiedString);

    //         function removeFirstAndLastThree(str) {
    //             return str.slice(3, -3);
    //         }
    //         const modifiedString1 = removeFirstAndLastThree('')
    //         const decodedStringaccessKeyID = decode(modifiedString1);

    //         const accessKeyId = decodedStringaccessKey;
    //         const secretAccessKey = decodedStringaccessKeyID;
    //         const region = process.env.REACT_APP_REGION;
    //         const bucketName =  "";

    //         const s3 = new S3({
    //             accessKeyId,
    //             secretAccessKey,
    //             region,
    //         });



    //         // Generate a pre-signed URL for downloading the object
    //         let params = {
    //             Bucket: bucketName,
    //             Key: decodedPath,
    //             Expires: expired_in ? "" : 3600, // URL will expire in 0.5 hour
    //         };


    //         const finalURL = s3.getSignedUrl('getObject', params);


    //         return finalURL;
    //     }
    //     catch (error) {
    //         throw error;
    //     }
    // }

    const summaryAccordHeading = (summHead, i) => {
        try {
            return (
                <>
                    <h2 className="accordion-header recruit-timeline-spacing" id={`headingTwo${i}`}>
                        <div className="row align-items-center">
                            <div className="col-md-4 py-3">
                                <button
                                    className="recruit-accordion-button w-auto px-0 regular-text collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseTwo${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseTwo${i}`}
                                >
                                    {summHead.interview_round_name}
                                </button>
                            </div>
                            <div className="col-md-5">
                                <div className="d-flex align-items-center">
                                    <span className="recruit-summary-initial bold-text">{summHead.interviewer.charAt(0)}</span>
                                    <div className="d-flex align-items-center recruit-border-right pe-4 flex-column">
                                        <span className="recruit-summary-username regular-text">
                                            {summHead.interviewer}
                                        </span>
                                        <div className="font-14 d-flex align-items-center ps-4 job-gps-label-color regular-text mt-2">
                                            {summHead.interview_data}
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="font-14 d-flex align-items-center  ps-4 regular-text">
                                            Email
                                        </div>
                                        <div className="font-14 d-flex align-items-center ps-4 job-gps-label-color regular-text mt-2">
                                            {summHead.email_sent == true ?
                                                <><span className="email-pointer me-2" /><span className="count-label-color">Sent</span>,by {summHead.email_sender ? summHead.email_sender : "-"}</> : <><span className="email-pointer-pending me-2" /><span className="count-label-color">Pending</span> {""}</>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                {summHead.overall_recommendation_id == 1 ? (
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src={'/Images/tick-task.svg'} className="me-2" />
                                        Selected
                                    </div>
                                ) : summHead.overall_recommendation_id == 2 ? (
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src={'/Images/Cross-task.svg'} className="me-2" />
                                        Rejected
                                    </div>
                                ) : summHead.overall_recommendation_id == 5 ? (
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src={'/Images/Interview-noshow.svg'} className="me-2" />
                                        No show
                                    </div>
                                ) : summHead.overall_recommendation_id == 4 ? (
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src={'/Images/delegate-icon.svg'} className="me-2" />
                                        Delegate
                                    </div>
                                ) : summHead.overall_recommendation_id == 3 ? (
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src={'/Images/onhold-icon.svg'} className="me-2" />
                                        OnHold
                                    </div>
                                ) : <></>}
                            </div>
                        </div>
                    </h2>

                </>
            );
        } catch (e) { }
    };

    const AccordBody = (summBody, bool) => {
        try {
            return (
                <>
                    {!bool &&
                        summBody.slice(0, 5)?.map((data) => {
                            let roundName = '';
                            if (data.round_assessment_id === 1) roundName = 'Attitude';
                            else if (data.round_assessment_id === 2) roundName = 'Communication';
                            else if (data.round_assessment_id === 3) roundName = 'Business';
                            else if (data.round_assessment_id === 4) roundName = 'Technology';
                            return (
                                <>
                                    <div className="mb-3">
                                        <p className="recruit-summary-ques mb-1 font-14 regular-text mb-2">{roundName}</p>
                                        <div className="custom-collapse-textarea font-14 regular-text">{data.comments}</div>
                                    </div>
                                </>
                            );
                        })}

                    <div className="mb-3">
                        <p className="recruit-summary-ques mb-1 font-14 regular-text mb-2">{'Over All Comments'}</p>
                        <div className="custom-collapse-textarea font-14 regular-text"> {summBody[0].overall_comments}</div>
                    </div>
                </>
            );
        } catch (e) { }
    };

    const summaryBind = () => {
        try {

            return summaryData?.map((summary, i) => {
                let data = {
                    interview_round_name: summary?.interview_round_name,
                    interviewer: JSON.parse(summary.scheduled_by)[1],
                    interview_data: moment(summary.interview_date).format('MMM DD, YYYY'),
                    overall_recommendation_id: summary.feedback[0]?.overall_recommendation_id,
                    email_sent: summary.feedback[0]?.is_check,
                    email_sender: summary.feedback[0]?.emp_name
                };
                return (
                    <div className="accordion-item border-0">
                        {summaryAccordHeading(data, i)}

                        <div
                            id={`collapseTwo${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`headingTwo${i}`}
                            data-bs-parent="#accordionExample"
                        >
                            <div className="accordion-body recruit-bg">
                                {AccordBody(summary.feedback, summary?.interview_round_name == 'Group Discussion' ? true : false)}
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };
    const fresherBind = () => {
        try {
            return fresherData?.map((evaluation, i) => {
                let interview_round_name =
                    evaluation.interview_round_id == 3
                        ? 'Technical Skill Test'
                        : evaluation.interview_round_id == 4
                            ? 'Coding Challenge'
                            : evaluation.interview_round_id == 2
                                ? 'Aptitude Test'
                                : '';

                return (
                    <>
                        <div className="accordion-item border-0">
                            <h2 className="accordion-header recruit-timeline-spacing" id={`heading${i}`}>
                                <div className="row align-items-center">
                                    <div className="col-md-5">
                                        <button
                                            className="recruit-accordion-button w-auto px-0 regular-text collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${i}`}
                                            aria-expanded="false"
                                            aria-controls={`collapse${i}`}
                                        >
                                            {interview_round_name}
                                        </button>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="d-flex align-items-center recruit-border-right pe-4">
                                                {/* <span className="recruit-summary-initial bold-text"></span> */}
                                                {/* <span className="recruit-summary-username regular-text"></span> */}
                                            </div>
                                            <div className="font-14 d-flex align-items-center ps-4 regular-text">
                                                {moment(evaluation.created_at).format('MMM DD, YYYY')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="font-14 d-flex justify-content-end">
                                            {evaluation.status == 'selected' ? (
                                                <>
                                                    <img src="/Images/tick-task.svg" className="me-2" alt="Tick Icon" />
                                                    <span> Selected</span>{' '}
                                                </>
                                            ) : null}
                                            {evaluation.status == 'submitted' ? (
                                                <>
                                                    <img src="/Images/submitted.svg" className="me-2 icon-height" alt="Tick Icon" />
                                                    <span className="mt-2"> Submitted</span>{' '}
                                                </>
                                            ) : null}
                                            {evaluation.status == 'rejected' ? (
                                                <>
                                                    <img src={'/Images/Cross-task.svg'} className="me-2" />
                                                    <span className="mt-2"> Rejected</span>{' '}
                                                </>
                                            ) : null}
                                            {evaluation.status == 'Malpractice' ? (
                                                <>
                                                    <img src={'/Images/malpractise.svg'} className="me-2 icon-height" />
                                                    <span className="mt-2"> Malpractice</span>{' '}
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </h2>
                            <div
                                id={`collapse${i}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`heading${i}`}
                                data-bs-parent={`#heading${i}`}
                            >
                                <div className="accordion-body recruit-bg">
                                    {/* {preliminaryData.map((prelim) => {
                                    return ( */}

                                    {evaluation.interview_round_id == 4 ? (
                                        <div className="mb-3">
                                            <p className="recruit-summary-ques mb-1 regular-text">{evaluation.question}</p>
                                            <p></p>
                                            <p className="recruit-summary-ans regular-text">
                                                {parse(evaluation.answer)}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="mb-3">
                                            <p className="recruit-summary-ques mb-1 regular-text">Scores</p>
                                            <p className="recruit-summary-ans regular-text">
                                                {evaluation?.score ? evaluation?.score : 0} out of 20
                                            </p>
                                        </div>
                                    )}

                                    {/* );
                                })} */}
                                </div>
                            </div>
                        </div>
                    </>
                );
            });
        } catch (e) { }
    };

    const summaryTab = () => {
        return (
            <div className="col-md-12 mt-4">
                <div className="card">
                    <div className="card-body p-4">
                        <p className="semibold-text font-16 ">Feedback</p>
                        <div className="accordion" id="accordionExample">
                            {premilaryBind()}
                            {experience == 'Fresher' && fresherBind()}
                            {summaryBind()}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="body-bg mt-3">
            <div className="container-fluid mt-5">
                <div className="row">
                    <BreadCrumbs data={breadCrumbsData} />
                    {/*Tab*/}
                    <div className="col-md-3">
                        {insertToast ? (
                            <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} />
                        ) : null}
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 recruit-spacing">
                                        <div className="float-start">
                                            <button
                                                hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                                type="button"
                                                className="btn hive-btn-outline small-button font-14"
                                                onClick={() => {
                                                    window.location.href = `/OfferLetter?id=${candidate_id}&exp=${experience}&jid=${JobID}&round='mwc'`;
                                                }}
                                            >
                                                View Offer
                                            </button>
                                            <div className="dropdown d-inline-block ms-3">
                                                <button
                                                    className="btn hive-btn-primary small-button font-12 dropdown-toggle medium-text"
                                                    id="recruitment-dropdown"
                                                    data-bs-toggle="dropdown"
                                                    data-bs-display="static"
                                                    aria-expanded="true"
                                                >
                                                    Advance{' '}
                                                </button>
                                                <ul
                                                    className="dropdown-menu dropdown-menu-end shadow dropdown-btn-adjust border-0"
                                                    aria-labelledby="recruitment-dropdown"
                                                    data-bs-popper="static"
                                                    style={{ width: 'max-content' }}
                                                >
                                                    {InterviewRoundDD?.map((interviewround) => {
                                                        return (
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    type="button"
                                                                    id={interviewround.id}
                                                                    name={interviewround.interview_round_name}
                                                                    onClick={(e) => {
                                                                        feedbackClick(e);
                                                                    }}
                                                                >
                                                                    {interviewround.interview_round_name}
                                                                </button>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="float-end">
                                            <div className="dropdown">
                                                <a
                                                    className="cursor-pointer px-2"
                                                    id="actionmenu-dropdown"
                                                    data-bs-toggle="dropdown"
                                                    data-bs-display="static"
                                                    aria-expanded="true"
                                                >
                                                    <img src="/Images/actionmenu.svg" alt="Action Icon" />
                                                </a>
                                                <ul
                                                    className="dropdown-menu dropdown-menu-end shadow border-0"
                                                    aria-labelledby="actionmenu-dropdown"
                                                    data-bs-popper="static"
                                                >
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            // onClick={() => {
                                                            //     rejectOrBlockClick('Rejected');
                                                            // }}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#logout11"
                                                        >
                                                            Reject
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={() => {
                                                                rejectOrBlockClick('Hold');
                                                            }}
                                                        >
                                                            Hold
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            // onClick={() => {
                                                            //     rejectOrBlockClick('Block');
                                                            // }}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#Block"
                                                        >
                                                            Block
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={() => {
                                                                setHideInterchange(false);
                                                            }}
                                                        >
                                                            Move to Another Job
                                                        </button>
                                                    </li>
                                                    {role == 'Recruiter' || role == 'Hiring Manager' ? (
                                                        <li>
                                                            <button
                                                                className="dropdown-item"
                                                                type="button"
                                                                hidden={hideGenerateOffer}
                                                                onClick={() => {
                                                                    window.location.href = `/OfferLetter?id=${candidate_id}&exp=${experience}&round='mwc'&jid=${JobID}`;
                                                                }}
                                                            >
                                                                Generate Offer
                                                            </button>
                                                        </li>
                                                    ) : null}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center m-auto mt-4">
                                        <img
                                            src={
                                                offerData?.offerletter_status == 'Offer Accepted'
                                                    ? '/Images/offerbatch.svg'
                                                    : offerData?.offerletter_status == 'Offer Rejected'
                                                        ? '/Images/offer-Rejected.svg'
                                                        : offerData?.offerletter_status == 'Offer Drafted'
                                                            ? '/Images/offer-Drafted.svg'
                                                            : offerData?.offerletter_status == 'Offer Sent'
                                                                ? '/Images/Offer-sent-yellow.svg'
                                                                : '/Images/Offer-NotDrafted.svg'
                                            }
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-12 text-center m-auto mt-2">
                                        <p className="bold-text mb-1 font-16">{overviewData?.first_name + ' ' + overviewData?.last_name}</p>
                                        <p className="mb-1 font-12 regular-text">{overviewData?.email_id}</p>
                                        <p className="mb-1 font-12 regular-text">{overviewData?.mobile_number}</p>
                                    </div>
                                    <div className="col-md-12 m-auto mt-4">
                                        <p className="font-12 mb-2 regular-text">Applied For</p>
                                        <div className="card rounded-pill">
                                            <div className="card-body py-1 px-4">
                                                <p className="mb-1 font-12 regular-text color-purple">{candidateJobsData?.job_title}</p>
                                                <p className="mb-0 font-10 regular-text">{candidateJobsData?.location}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <ul className="list-unstyled text-center">
                                            <li className={`recruit-stage font-14 ${highLightColor1}`}>
                                                1
                                                <ul className="list-unstyled position-absolute recruit-stage-detail pt-4">
                                                    <li>
                                                        <div className="card rounded-pill text-start recruit-stage-bg">
                                                            <div className="card-body py-2 px-4">
                                                                <p className="mb-1 font-12 color-purple regular-text">
                                                                    {candidateJobsData?.stage}{' '}
                                                                </p>
                                                                <p className="mb-0 font-10 text-dark regular-text">
                                                                    {offerData?.offerletter_status == ''
                                                                        ? 'Offer Not Drafted'
                                                                        : offerData.offerletter_status}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={`recruit-stage font-14 ${highLightColor2}`}>2</li>
                                            <li className={`recruit-stage font-14 ${highLightColor3}`}>3</li>
                                            <li className={`recruit-stage font-14 ${highLightColor4}`}>4</li>
                                            <li className={`recruit-stage font-14 ${highLightColor5}`}>5</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-12 custom-margin">
                                        <p className="font-12 mb-2 regular-text">Owner</p>
                                        <div className="dropdown border-bottom pb-3">
                                            <span
                                                className="btn border py-3 w-100 font-12 medium-text text-start"
                                                id="owner-dropdown"
                                                data-bs-toggle="dropdown"
                                                data-bs-display="static"
                                                aria-expanded="true"
                                            >
                                                <span className="recruit-owner-initial px-3 py-2">
                                                    {candidateJobsData.posted_by?.split('')[0]}
                                                </span>
                                                <span className="recruit-owner-fullname bold-text ms-1">
                                                    {candidateJobsData?.posted_by}
                                                </span>
                                            </span>
                                            {/* <ul className="dropdown-menu shadow owner-list-dropdown border-0 w-100" aria-labelledby="owner-dropdown" data-bs-popper="static">
                                                            <li>
                                                                 <button className="dropdown-item py-3 font-12" type="button">
                                                                      <span className="recruit-owner-initial">M</span>
                                                                      <span className="recruit-owner-fullname">Manikandan M</span>
                                                                 </button>
                                                            </li>
                                                            <li>
                                                                 <button className="dropdown-item py-3 font-12" type="button">
                                                                      <span className="recruit-owner-initial">R</span>
                                                                      <span className="recruit-owner-fullname">Jeyanth</span>
                                                                 </button>
                                                            </li>
                                                       </ul> */}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3 d-flex">
                                        <div className="float-start">
                                            <img src="/Images/pdf.svg" alt="pdf icon" />
                                        </div>
                                        <div className="ms-2">
                                            <a
                                                href="#"
                                                style={{cursor:"pointer"}} onClick={async (e) => {
                                                    e.preventDefault();
                                                    window.open(await getS3(overviewData?.resume_url, "1"), "_blank");
            
            
                                                }} 
                                                // onClick={(e) => {
                                                //     e.preventDefault();
                                                //     const url = getS3(overviewData?.resume_url, "1");
                                                //     window.open(url, '_blank');
                                                // }}
                                                className="d-block font-13 color-darkblue bold-text text-decoration-none"
                                            >
                                                {overviewData?.resume_url?.split('/').pop()}
                                            </a>
                                            <span className="interview-gray-color font-13">
                                                {moment(candidateJobsData?.created_at).format('ll')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div hidden={hideInterchange} className="body-bg">
                        <div className="container-fluid ">
                            <div className="row justify-content-center">
                                {/*offcanvas section starts here*/}
                                <div className="hold-candidate" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                    <div className="offcanvas-header mb-4">
                                        <h5 className="mb-0 bold-text font-18 hold-candidates-header-color">Move to another job</h5>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setHideInterchange(true);
                                                cancelClick('Move');
                                            }}
                                            className="btn-close"
                                            data-bs-dismiss="offcanvas"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="offcanvas-body">
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="candidate">
                                                Search and pick your job posting
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select regular-text custom-textfield"
                                                id="job_id"
                                                onChange={(e) => {
                                                    setInterchangeData({
                                                        ...interchangeData,
                                                        ['job_id']: e.target.value.split('@')[0],
                                                        ['job_title']: e.target.value.split('@')[1],
                                                    });
                                                }}
                                            >
                                                <option className="">Select</option>
                                                {bindJobsTitle()}
                                            </select>
                                        </div>
                                        <div hidden={interchangeData.job_title == '' ? true : false}>
                                            <img src="/Images/alert.png" className=" me-2 icon-size mb-1" />
                                            <span>
                                                Any upcoming interview under the job "{jobTitle}" will be cancelled for the candidate
                                            </span>
                                        </div>
                                        <div className="mt-4 ms-1">
                                            <input
                                                className="form-check-input mt-0 recruitment-checkBox"
                                                type="checkbox"
                                                checked
                                                disabled
                                            />{' '}
                                            <span className="ps-2 font-16">Notify Candidate</span>
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-end" style={{ marginTop: '460px' }}>
                                            <button
                                                className="btn hive-btn-secondary me-2"
                                                onClick={() => {
                                                    setHideInterchange(true);
                                                    cancelClick('Move');
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button className="btn hive-btn-primary" onClick={() => submitHold('InterChange')}>
                                                Move
                                            </button>
                                        </div>
                                    </div>
                                    {/*offcanvas body ends here*/}
                                </div>
                                <div className="modal-backdrop fade show"></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="card">
                            <div className="card-body">
                                <ul className="nav nav-pills ps-1 border-bottom font-14" id="pills-tab" role="tablist">
                                    <li className="nav-item me-5 ">
                                        <button
                                            className="nav-link rounded-0 px-0 active bold-text tab-style"
                                            id="summary-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#summary-tab-recruitment"
                                            type="button"
                                            role="tab"
                                            aria-controls="summary-tab"
                                            aria-selected="true"
                                        >
                                            Summary
                                        </button>
                                    </li>
                                    <li className="nav-item me-5">
                                        <button
                                            className="nav-link rounded-0 px-0 bold-text tab-style"
                                            id="profile-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#profile-tab-recruitment"
                                            type="button"
                                            role="tab"
                                            aria-controls="profile-tab"
                                            aria-selected="false"
                                        >
                                            Profile
                                        </button>
                                    </li>
                                    <li className="nav-item me-5">
                                        <button
                                            className="nav-link rounded-0 px-0 bold-text tab-style"
                                            id="interview-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#interview-tab-recruitment"
                                            type="button"
                                            role="tab"
                                            aria-controls="interview-tab"
                                            aria-selected="false"
                                        >
                                            Interviews
                                        </button>
                                    </li>
                                    <li className="nav-item me-5">
                                        <button
                                            className="nav-link rounded-0 px-0 bold-text tab-style"
                                            id="offer-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#offer-tab-recruitment"
                                            type="button"
                                            role="tab"
                                            aria-controls="offer-tab"
                                            aria-selected="true"
                                        >
                                            Offer
                                        </button>
                                    </li>
                                    {experience == 'Experienced' && (
                                        <li className="nav-item me-5">
                                            <button
                                                className="nav-link rounded-0 px-0 bold-text tab-style"
                                                id="task-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#task-tab-recruitment"
                                                type="button"
                                                role="tab"
                                                aria-controls="task-tab"
                                                aria-selected="false"
                                            >
                                                Tasks
                                            </button>
                                        </li>
                                    )}
                                    <li className="nav-item me-5">
                                        <button
                                            className="nav-link rounded-0 px-0 bold-text tab-style"
                                            id="timeline-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#timeline-tab-recruitment"
                                            type="button"
                                            role="tab"
                                            aria-controls="timeline-tab"
                                            aria-selected="false"
                                        >
                                            Timeline
                                        </button>
                                    </li>
                                    {onboard_id == 'onboard' ? (
                                        <li className="nav-item me-5">
                                            <button
                                                className="nav-link rounded-0 px-0 bold-text tab-style"
                                                id="basicdetails-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#basicdetails-tab-recruitment"
                                                type="button"
                                                role="tab"
                                                aria-controls="basicdetails-tab"
                                                aria-selected="false"
                                                hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                            >
                                                Basic Details
                                            </button>
                                        </li>
                                    ) : null}
                                    {onboard_id == 'onboard' ? (
                                        <li className="nav-item">
                                            <button
                                                className="nav-link rounded-0 px-0 bold-text tab-style"
                                                id="documentdetails-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#documentdetails-tab-recruitment"
                                                type="button"
                                                role="tab"
                                                aria-controls="documentdetails-tab"
                                                aria-selected="false"
                                                hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}
                                            >
                                                Document Details
                                            </button>
                                        </li>
                                    ) : null}
                                </ul>

                                <div className="tab-content" id="pills-tabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="summary-tab-recruitment"
                                        role="tabpanel"
                                        aria-labelledby="summary-tab"
                                    >
                                        <div className="row">
                                            <div className="col-md-12 mt-4">
                                                <div className="card">
                                                    <div className="card-body p-4">
                                                        <p className="semibold-text font-16">Offer Details</p>
                                                        <div className="row">
                                                            {offerData?.offerletter_status !== 'Rejected' ? (
                                                                <>
                                                                    <div className="col-md-3">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Status
                                                                        </label>
                                                                        <label className="recruit-accept regular-text">
                                                                            {offerData?.offerletter_status == '' ||
                                                                                offerData?.offerletter_status == null
                                                                                ? 'Offer Not Drafted'
                                                                                : offerData.offerletter_status}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Accepted On
                                                                        </label>
                                                                        <label className="regular-text">
                                                                            {offerData.offerletter_status == 'Offer Accepted'
                                                                                ? moment(offerData.modified_at).format('ll')
                                                                                : '-'}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Onboarding Date
                                                                        </label>
                                                                        <label className="regular-text">
                                                                            {offerData?.on_boarding_date == '' ||
                                                                                offerData?.on_boarding_date == undefined
                                                                                ? '-'
                                                                                : moment(offerData.on_boarding_date).format('ll')}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Annual Salary
                                                                        </label>
                                                                        <label className="regular-text">
                                                                            {offerData?.annual_ctc == '' ? '-' : offerData.annual_ctc}{' '}
                                                                            {/* {offerData.currency_type == undefined
                                                                                ? '-'
                                                                                : offerData.currency_type} */}
                                                                        </label>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="col-md-4">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Status
                                                                        </label>
                                                                        <label className="recruit-reject regular-text">
                                                                            {offerData?.offerletter_status == '' ||
                                                                                offerData?.offerletter_status == null
                                                                                ? 'Offer Not Drafted'
                                                                                : offerData.offerletter_status}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Rejected On
                                                                        </label>
                                                                        <label className="regular-text">
                                                                            {offerData?.modified_at == '' &&
                                                                                offerData?.on_boarding_date !== '' &&
                                                                                offerData?.on_boarding_date !== null
                                                                                ? '-'
                                                                                : moment(offerData.modified_at).format('ll')}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label className="w-100 recruit-summary-label regular-text">
                                                                            Reason
                                                                        </label>
                                                                        <label className="regular-text">
                                                                            {rejectdata?.reason == '' ||
                                                                                rejectdata?.reason == undefined ||
                                                                                rejectdata?.reason == null
                                                                                ? '-'
                                                                                : rejectdata?.reason}
                                                                        </label>
                                                                    </div>
                                                                    <div className="mt-3">
                                                                        <div className="col-md-3">
                                                                            <label className="w-100 recruit-summary-label regular-text">
                                                                                Comments
                                                                            </label>
                                                                            <label className="regular-text">
                                                                                {rejectdata?.detailed_reason == '' ||
                                                                                    rejectdata?.detailed_reason == undefined ||
                                                                                    rejectdata?.detailed_reason == null
                                                                                    ? '-'
                                                                                    : rejectdata?.detailed_reason}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <RecruitmentPopup
                                            deleteData={() => {
                                                rejectOrBlockClick('Rejected');
                                            }}
                                        />
                                        <BlockPopup
                                            deleteData={() => {
                                                rejectOrBlockClick('Block');
                                            }}
                                        />
                                        {summaryTab()}
                                    </div>

                                    <div
                                        className="tab-pane fade"
                                        id="profile-tab-recruitment"
                                        role="tabpanel"
                                        aria-labelledby="profile-tab"
                                    >
                                        <CandidateProfile candidate_id={candidate_id} experience={experience} profileData={overviewData} />
                                    </div>

                                    {/* Profile Tab- Ends Here */}
                                    {/* Interview Tab */}
                                    <div
                                        className="tab-pane fade"
                                        id="interview-tab-recruitment"
                                        role="tabpanel"
                                        aria-labelledby="interview-tab"
                                    >
                                        <CandidateInterview
                                            candidate_id={candidate_id}
                                            experience={experience}
                                            jobId={candidateJobsData.job_id}
                                            candidateName={overviewData.first_name}
                                            email={overviewData.email_id}
                                            candidate_profile_url={overviewData.candidate_photo_url}
                                        />

                                        {/*offcanvas section ends here*/}
                                    </div>
                                    {/* Interview Tab - ends here */}
                                    {/* Offer Tab */}
                                    <div className="tab-pane fade" id="offer-tab-recruitment" role="tabpanel" aria-labelledby="offer-tab">
                                        <CandidateOffer
                                            candidate_id={candidate_id}
                                            experience={experience}
                                            offerDetails={offerData}
                                            reportingDetails={reportingDetails}
                                            jobDetails={candidateJobsData}
                                            rejectdetails={rejectdata}
                                        ></CandidateOffer>
                                    </div>
                                    {/* Offer Tab - Ends Here */}
                                    {/* Task Tab */}
                                    <div className="tab-pane fade" id="task-tab-recruitment" role="tabpanel" aria-labelledby="task-tab">
                                        <CandidateTask
                                            candidate_id={candidate_id}
                                            experience={experience}
                                            jobId={candidateJobsData.job_id}
                                            candidate_name={overviewData?.first_name + ' ' + overviewData?.last_name}
                                            email={overviewData?.email_id}
                                        ></CandidateTask>
                                    </div>
                                    {/* Task Tab - Ends here */}
                                    {/* Timeline tab - starts here */}
                                    <div
                                        className="tab-pane fade"
                                        id="timeline-tab-recruitment"
                                        role="tabpanel"
                                        aria-labelledby="timeline-tab"
                                    >
                                        <CandidateTimeline candidate_id={candidate_id} experience={experience}></CandidateTimeline>
                                    </div>
                                    {/* Timeline tab - ends here */}
                                    {/* Basic Details */}
                                    {onboard_id == 'onboard' ? (
                                        <div
                                            className="tab-pane fade"
                                            id="basicdetails-tab-recruitment"
                                            role="tabpanel"
                                            aria-labelledby="basicdetails-tab"
                                        >
                                            <CandidateBasicDetails
                                                candidate_id={candidate_id}
                                                experience={experience}
                                            ></CandidateBasicDetails>
                                        </div>
                                    ) : null}
                                    {/* Basic Details - Ends here */}
                                    {/* Document Tab */}
                                    {onboard_id == 'onboard' ? (
                                        <div
                                            className="tab-pane fade"
                                            id="documentdetails-tab-recruitment"
                                            role="tabpanel"
                                            aria-labelledby="documentdetails-tab"
                                        >
                                            <CandidateDocumentDetails
                                                candidate_id={candidate_id}
                                                experience={experience}
                                            ></CandidateDocumentDetails>
                                        </div>
                                    ) : null}
                                    {/* Document Tab - Ends here */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
